import styles from "./Status.module.css";
import StatusCircle from "./StatusCircle";
import { ApplicationStatus } from "./StatusTypes";

export default function Status(props:ApplicationStatus){
    return(
        <div className={styles.status}>
          <StatusCircle color={props.color} />
          <div className={styles.statustext}>
            {props.isActive == true ? "Active" : "Inactive"}
          </div>
        </div>
    )
}

  